import Bowser from "bowser";
import { Device, DeviceMap, Platform, PlatformMap } from "../proto/Global_pb";
import { InfoWallpaper } from "../proto/InfoWallpaper_pb";
import { getStorage, setStorage } from "./storage";
import { STORAGE_LOCATION_PERMISSION_STATUS, STORAGE_USER_LOCATION } from "../constants/localstorage";
import { toast } from "./utils";
import { locationPermission } from "../constants/globals";
import { goToPopup } from "./services";
import { POPUP_NEAR_BY } from "../constants/routes";

const userAgent = Bowser.parse(window.navigator.userAgent);

export const agentBrowserName = (): string => {
  return userAgent.browser.name || "undefined";
};

export const agentBrowserVersion = (): string => {
  return userAgent.browser.version || "undefined";
};

export const agentPlatform = (): PlatformMap[keyof PlatformMap] => {
  switch (userAgent.os.name) {
    case "Android":
      return Platform["ANDROID"];
    case "iOS":
      return Platform["IOS"];
    case "macOS":
      return Platform["MAC_OS"];
    case "Windows":
      return Platform["WINDOWS"];
    case "Linux":
      return Platform["LINUX"];
    case "Black_berry":
      return Platform["BLACK_BERRY"];
    default:
      return Platform["UNKNOWN_PLATFORM"];
  }
};

export const agentDevice = (): DeviceMap[keyof DeviceMap] => {
  switch (userAgent.platform.type) {
    case "desktop":
      return Device["PC"];
    case "tablet":
      return Device["TABLET"];
    case "mobile":
      return Device["MOBILE"];
    default:
      return Device["UNKNOWN_DEVICE"];
  }
};

export const agentFit = (): InfoWallpaper.FitMap[keyof InfoWallpaper.FitMap] => {
  switch (userAgent.platform.type) {
    case "tablet":
      return InfoWallpaper.Fit.TABLET;
    case "mobile":
      return InfoWallpaper.Fit.PHONE;
    default:
      return InfoWallpaper.Fit.DESKTOP;
  }
};

export const handlePermission = (): any => {
  return navigator.permissions.query({ name: "geolocation" }).then(function (result) {
    if (result.state === "granted") {
      setStorage(STORAGE_LOCATION_PERMISSION_STATUS, result.state);
      return result.state;
      // geoBtn.style.display = "none";
    } else if (result.state === "prompt") {
      navigator.geolocation.getCurrentPosition(revealPosition, positionDenied);
      return result.state; // geoBtn.style.display = "none";
    } else if (result.state === "denied") {
      setStorage(STORAGE_LOCATION_PERMISSION_STATUS, result.state);
      return result.state;
      // geoBtn.style.display = "inline";
    }
    // result.onchange = function () {
    //   report(result.state);
    // };
    return result.state;
  });
};

const revealPosition = (data: any) => {
  setStorage(STORAGE_USER_LOCATION, { lat: data.coords.latitude, lng: data.coords.longitude });
};
const positionDenied = (data: any) => {
};

export const handleNearby = () => {
  handlePermission().then((res: any) => {
    if (res === locationPermission.Granted && getStorage(STORAGE_USER_LOCATION)) {
      goToPopup(POPUP_NEAR_BY);
    }
    if (res === locationPermission.Granted && !getStorage(STORAGE_USER_LOCATION)) {
      toast("موقعیت شما شناسایی نشد", { variant: "info" });
    }
    if (res === locationPermission.Denied) {
      toast("ابتدا دسترسی موقعیت مکانی را وارد کنید", { variant: "info" });
    }
    if (res !== locationPermission.Granted && res !== locationPermission.Denied) {
      // handleNearby();
      handlePermission();
    }
  });
};
